module.exports = __webpack_public_path__ + "static/images/goods-active.f9893c3.png";